'use client';
import { RefObject, useEffect, useState } from 'react';

const useIsInView = (containerRef: RefObject<HTMLDivElement | null>) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true);
            observer.unobserve(entry.target); // Stop observing once it's in view
          }
        });
      },
      { threshold: 0.1 },
    );

    const container = containerRef?.current;
    if (container) {
      observer.observe(container);
    }

    return () => {
      if (container) {
        observer.unobserve(container);
      }
    };
  }, [containerRef]);

  return isInView;
};

export default useIsInView;
